import '@tensorflow/tfjs-backend-webgl';
import { Injectable } from '@angular/core';
import * as tf from '@tensorflow/tfjs-core';


import * as mpPose from '@mediapipe/pose';
import * as mpSelfieSegmentation from '@mediapipe/selfie_segmentation';
import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm';

tfjsWasm.setWasmPaths(
    `https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`);

import * as bodySegmentation from '@tensorflow-models/body-segmentation';
import * as poseDetection from '@tensorflow-models/pose-detection';

import { BehaviorSubject, Observable } from 'rxjs';
import { Camera } from './shared/camera';
import { STATE } from './shared/params';
import { setBackendAndEnvFlags } from './shared/util';
import { RendererCanvas2d } from './shared/renderer_canvas2d';

@Injectable({
    providedIn: 'root'
})
export class BodySegmentationService {
    private _readyState: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public readonly isReady$: Observable<boolean> = this._readyState.asObservable();

    constructor() {

    }

    detector: any;
    segmenter: any;
    camera: any;
    stats: any;
    cameras: any;
    fpsDisplayMode = 'model';
    resetTime = {
        startInferenceTime: 0,
        numInferences: 0,
        inferenceTimeSum: 0,
        lastPanelUpdate: 0
    };
    modelTime = { ...this.resetTime };
    E2ETime = { ...this.resetTime };
    rafId;
    MODEL_LABEL = '(Model FPS)';
    E2E_LABEL = '(End2End FPS)';
    canvas = document.createElement('canvas');
    ctx = this.canvas.getContext('2d');
    renderer:RendererCanvas2d;
    useGpuRenderer = false;
    videoHtmlElement:any;
    static selfRef:any;

    async startPoseDetection( video:any, videoHtml:any, videoCanvas:any) {
        BodySegmentationService.selfRef = this;
        this.videoHtmlElement = videoHtml;
        this.camera = video;

        await setBackendAndEnvFlags(STATE.flags, STATE.backend);
        await tf.ready();
        this.detector = await this.createDetector();
        // videoCanvas.width = this.camera['_constraints'].width;
        // videoCanvas.height = this.camera['_constraints'].height;

        this.renderer = new RendererCanvas2d(videoCanvas);

        this.renderPrediction();
    }

    createDetector() {
        switch (STATE.model) {
            case poseDetection.SupportedModels.PoseNet:
                return poseDetection.createDetector(STATE.model, {
                    quantBytes: 4,
                    architecture: 'MobileNetV1',
                    outputStride: 16,
                    inputResolution: { width: 500, height: 500 },
                    multiplier: 0.75
                });

        }
    }

    async checkGuiUpdate() {
      //  console.log(STATE.isModelChanged ,' ', STATE.isFlagChanged ,' ', STATE.isBackendChanged, ' ',STATE.isTargetFPSChanged ,' ', STATE.isSizeOptionChanged)
        if (STATE.isTargetFPSChanged || STATE.isSizeOptionChanged) {
           // this.camera = await Camera.setup(STATE.camera);
            STATE.isTargetFPSChanged = false;
            STATE.isSizeOptionChanged = false;
        }

        if (STATE.isModelChanged || STATE.isFlagChanged || STATE.isBackendChanged) {
            STATE.isModelChanged = true;

            window.cancelAnimationFrame(this.rafId);

            if (this.detector != null) {
                this.detector.dispose();
            }

            if (STATE.isFlagChanged || STATE.isBackendChanged) {
                await setBackendAndEnvFlags(STATE.flags, STATE.backend);
            }

            try {
                this.detector = await this.createDetector();
            } catch (error) {
                this.detector = null;
                alert(error);
            }

            STATE.isFlagChanged = false;
            STATE.isBackendChanged = false;
            STATE.isModelChanged = false;
        }
    }

    async renderResult() {
   
        let poses = null;
        let canvasInfo = null;

        // Detector can be null if initialization failed (for example when loading
        // from a URL that does not exist).
        if (this.detector != null) {
            // FPS only counts the time it takes to finish estimatePoses.


            if (this.useGpuRenderer && STATE.model !== 'PoseNet') {
                throw new Error('Only PoseNet supports GPU renderer!');
            }
            // Detectors can throw errors, for example when using custom URLs that
            // contain a model that doesn't provide the expected output.
            try {
                if (this.useGpuRenderer) {
                    const [posesTemp, canvasInfoTemp] = await this.detector.estimatePosesGPU(
                        this.camera.getCurrentFrameData(),
                        { maxPoses: STATE.modelConfig.maxPoses, flipHorizontal: false },
                        true);
                    poses = posesTemp;
                    canvasInfo = canvasInfoTemp;
                } else {
                    poses = await this.detector.estimatePoses(
                        this.camera.getCurrentFrameData(),
                        { maxPoses: STATE.modelConfig.maxPoses, flipHorizontal: false });      
                      
                }
            } catch (error) {
                this.detector.dispose();
                this.detector = null;
                alert(error);
            }

        }
        const bitmap = await createImageBitmap(this.camera.getCurrentFrameData());
        const rendererParams = this.useGpuRenderer ?
            [ bitmap, poses, canvasInfo, STATE.modelConfig.scoreThreshold] :
            [bitmap, poses, STATE.isModelChanged];
        this.renderer.draw(rendererParams);
    }



    async renderPrediction() {
        await BodySegmentationService.selfRef.checkGuiUpdate();

        if (!STATE.isModelChanged) {
            await BodySegmentationService.selfRef.renderResult();
        }

        BodySegmentationService.selfRef.rafId = requestAnimationFrame(BodySegmentationService.selfRef.renderPrediction);
    }

}